export default {"src":"/_next/static/media/fetchingLinkedAccounts.0a52e899.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};